import React from 'react';
import PropTypes from 'prop-types';
import AFeaturedImage from '../atoms/_atoms.featured-image';

export default class MProductGallery extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			featured: props.featuredImage,
			images: props.items.map(item => item.url),
		};
	}

	componentWillReceiveProps(props) {
		if (props.featuredImage !== this.state.featured) {
			this.setState({ featured: props.featuredImage });
		}
		if (props.items !== this.state.images) {
			this.setState({ images: props.items.map(item => item.url) });
		}
	}

	bindHandles() {
		this.handleClick = this.handleClick.bind(this);
		this.handleKeyDown = this.handleKeyDown.bind(this);
	}

	handleClick({ image }) {
		const index = this.state.images.indexOf(image);
		const images = this.state.images; // eslint-disable-line

		images[index] = this.state.featured;

		this.setState({ featured: image, images });
	}

	handleKeyDown({ event, image }) {
		if (event.keyCode === 13) {
			this.handleClick({ image });
		}
	}

	render() {
		let i = 0;
		const hiddenDivs = [];
		const showVideo = this.props.showVideo && this.state.featured === this.props.featuredImage ?
			this.props.showVideo : undefined;

		if (this.state.images.length && this.state.images.length < 3) {
			for (let c = 0, v = 3 - this.state.images.length; c < v; c++) {
				hiddenDivs.push(<figure className="not-set" key={c} />);
			}
		}

		return (
			<section className={`m-product-gallery ${this.props.className}`}>
				<article className="m-product-gallery-featured">
					<AFeaturedImage
						img={this.state.featured}
						showVideo={showVideo}
						onClick={this.props.onClick}
					/>
				</article>
				<article className="m-product-gallery-preview">
					{
						this.state.images.map((image) => {
							i += 1;
							return (
								<figure
									role="button"
									tabIndex={0}
									key={i}
									onClick={() => this.handleClick({ image })}
									onKeyDown={event => this.handleKeyDown({ event, image })}
								>
									<img src={image} alt="" />
								</figure>
							);
						})
					}
					{hiddenDivs}
				</article>
			</section>
		);
	}
}

MProductGallery.propTypes = {
	featuredImage: PropTypes.string.isRequired,
	items: PropTypes.array.isRequired,
	showVideo: PropTypes.bool,
	className: PropTypes.string,
	onClick: PropTypes.func,
};

MProductGallery.defaultProps = {
	showVideo: false,
	className: undefined,
	onClick: undefined,
};



// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.product-gallery.js